module.exports = __webpack_public_path__ + "assets/img/JZ.86c2d783.png";